import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { UserSettingsService } from '../../user/services';
import { UserSetting } from '../../user/models';
import { Guid } from '../../shared/utils';

@Injectable({
    providedIn: 'root'
})
export class PartnerFavoritesService {

    userSettingKey = 'Saved_PartnerFavorite_';
    userSettingGroupKey = 'Saved_PartnerFavorites';

    saveSearchSubject: Subject<SavedPartnerFavorite> = new Subject<SavedPartnerFavorite>();
    public saveSearchObserver = this.saveSearchSubject.asObservable();

    constructor(private userSettingsService: UserSettingsService) { }

    public getSearches(): Promise<SavedPartnerFavorite[]> {
        return this.userSettingsService.getUserSettingsByGroup(this.userSettingGroupKey).then((userSettings: UserSetting[]) => {
            const searches: SavedPartnerFavorite[] = [];
            if (userSettings && userSettings.length > 0) {
                userSettings = userSettings.sort((us1, us2) => us1.Value1.localeCompare(us2.Value1));
                return userSettings.map((us) => new SavedPartnerFavorite(us.Value1, JSON.parse(us.Value2), us));
            }
            else {
                return Promise.resolve(searches);
            }
        });
    }

    public saveSearch(searchToSave: SavedPartnerFavorite): Promise<void> {
        const userSetting = searchToSave.userSetting || new UserSetting(this.userSettingKey + Guid.newGuid(), this.userSettingGroupKey, searchToSave.name, JSON.stringify(searchToSave.params));
        return this.userSettingsService.saveSingleSettings(userSetting).then(() => {
            this.saveSearchSubject.next(searchToSave);
        });
    }

    public deleteSearch(searchToDelete: SavedPartnerFavorite): Promise<void> {
        if (searchToDelete.userSetting) {
            return this.userSettingsService.deleteSetting(searchToDelete.userSetting.Key, null);
        }
        else {
            return Promise.resolve();
        }
    }
}

export class SavedPartnerFavorite {

    constructor(public name: string, public params: any, public userSetting?: UserSetting) { } // UserSetting is set so it's possible to update the saved search, when that should be supported...
}
